<template>
  <div class="sample-main">
    <!-- <textarea style="display: inline-block" v-html="content"></textarea> -->
    <div style="display: inline-block" contenteditable="true" @input="divInput" @keydown="keydown" ref="mydiv"></div>
    <button @click="testClicked">Test</button>
    <button @click="testClicked2">Test2</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      content: '',
    };
  },
  props: {},
  methods: {
    testClicked: function () {
      console.log(this.content);
    },
    testClicked2: function () {
      // console.log(document.getSelection());
      // console.log(document.getSelection().getRangeAt(0));
      // document.execCommand('bold');
      let el = this.$refs['mydiv'];
      document.execCommand('bold');
      el.focus();
      // setTimeout(() => {
      //   console.log('test');
      //   let ke = new KeyboardEvent('keydown', { key: 'b', ctrlKey: false });
      //   el.dispatchEvent(ke);
      // }, 1000);
    },
    keydown: function (e) {
      console.log(e);
    },
    divInput: function (e) {
      this.content = e.target.innerHTML;
      if (this.content.endsWith('<br>')) {
        this.content = this.content.substring(0, this.content.length - 4);
      }
    },
  },
  async mounted() {
    var userDetails = await this.$apiCallV2(`/Login/GetDetails`);
    console.log(userDetails);
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.sample-main {
  font-size: 12px;

  > div {
    border: 1px solid gray;
    width: 500px;
    height: 500px;
    overflow: auto;
    font-size: 2em;

    &:focus {
      outline: none;
    }
  }
}
</style>
